import { render, staticRenderFns } from "./UserDashboardNotificationsBox.vue?vue&type=template&id=f3ee4fc0&scoped=true&"
import script from "./UserDashboardNotificationsBox.vue?vue&type=script&lang=js&"
export * from "./UserDashboardNotificationsBox.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardNotificationsBox.vue?vue&type=style&index=0&id=f3ee4fc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ee4fc0",
  null
  
)

export default component.exports